import { HStack, Pressable, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { DocumentCardProps } from "@repo/core/screens/PreProposal/screens/SelectDocuments/DocumentCard/types";

import { MustShow } from "@repo/core/components/core/MustShow";
import { Icon } from "@repo/core/components/core/Icon";

export const DocumentCard = ({
  title,
  hasSelectedFile,
  isUploaded = false,
  onPress
}: DocumentCardProps) => {
  const isCompleted = isUploaded || hasSelectedFile;

  return (
    <Pressable
      height="$32"
      maxHeight="$32"
      onPress={onPress}
      disabled={!onPress}
      opacity={onPress ? 1 : 0.6}
    >
      <VStack
        flex={1}
        height="$32"
        maxHeight="$32"
        borderRadius="$lg"
        borderWidth={2}
        borderColor={
          isCompleted
            ? "$success700"
            : hasSelectedFile
              ? "$primary700"
              : "$borderLight100"
        }
        bg={
          isCompleted
            ? "$success50"
            : hasSelectedFile
              ? "$primary0"
              : "$backgroundLight50"
        }
      >
        <HStack flex={1} gap="$4" alignItems="center" px="$4">
          <Icon
            name="file"
            size={80}
            color={isCompleted ? "$success700" : "$primary700"}
          />
          <VStack flex={1} alignItems="flex-start">
            <Text fontWeight={500} fontSize="$lg">
              {title}
            </Text>
            {isUploaded && (
              <Text fontSize="$xs" color="$success700" mt="$1">
                Enviado com sucesso
              </Text>
            )}
            {isCompleted ? (
              <Text fontSize="$xs" color="$textLight500" mt="$1">
                Toque para substituir o arquivo
              </Text>
            ) : (
              <Text fontSize="$xs" color="$textLight500" mt="$1">
                Toque para enviar
              </Text>
            )}
          </VStack>
          <MustShow isVisible={isCompleted}>
            <VStack position="absolute" top="$2" right="$2">
              <Icon
                name="check-circle"
                size={24}
                color={isUploaded ? "$success700" : "$primary700"}
              />
            </VStack>
          </MustShow>
        </HStack>
      </VStack>
    </Pressable>
  );
};
